import { ModelBase } from '../../core/model/model-base';
import { DimensionLabels } from './dimension-labels';

export class AccountPlanDimensions extends ModelBase implements DimensionLabels {
  constructor() {
    super();
  }

  enableCostPlace: boolean;
  enableCostBearer: boolean;
  enableCounterPart: boolean;
  enableProject: boolean;
  enableArticleCostPlace: boolean;
  enableFunction: boolean;
  counterpartDefaultValue: string;
  costPlaceLabel: string;
  costBearerLabel: string;
  projectLabel: string;
  counterpartLabel: string;
  functionLabel: string;
}
